import { createFileRoute } from '@tanstack/react-router';
import { LedgerTransferDetailPage } from './LedgerTransferDetailPage';

export const Route = createFileRoute(
  '/_protected/admin/internal-tools/ledger/transfers/$transferId/',
)({
  component: LedgerTransferDetailPage,
});
